import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#EB2961" }}>Brief</span>
            </h2>
            <p>
              Talpool is a leading networking platform where models,
              photographers, makeup artists, designers and people of other
              talents can create their portfolios to get the right exposure and
              find new projects.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#EB2961" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#EB2961" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#EB2961" }}> WEBSITE DEVELOPMENT</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
